import Axios from 'axios'

export const http = Axios.create({
  timeout: 15000,
  baseURL: 'https://api.cappasity.com/',
})



// WEBPACK FOOTER //
// ./src/http.ts